// Thin fetch layer for the Safety Dashboard's GET /api/safety/* endpoints.
// All routes are admin-gated server-side (@require_auth view_safety_dashboard);
// the idToken rides on every call via authHeaders().
import { authHeaders } from '../../utils/authHeader';

async function get(path, params = {}) {
  const qs = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  ).toString();
  const res = await fetch(`/api/safety/${path}${qs ? `?${qs}` : ''}`, {
    headers: await authHeaders(),
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok || body.success === false) {
    const err = new Error(body.error || `safety/${path} failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return body;
}

export const fetchStates = () => get('states');
export const fetchCollections = (state) => get('collections', { state });
export const fetchCorridor = (state, route, pathId, direction) =>
  get('corridor', { state, route, path_id: pathId, direction });
export const fetchAnalysis = (state, route, pathId, direction, analysis) =>
  get('analysis', { state, route, path_id: pathId, direction, analysis });
export const fetchCrashes = (state, route, pathId) =>
  get('crashes', { state, route, path_id: pathId });
export const fetchVerdict = (state, route, pathId, force = false) =>
  get('verdict', { state, route, path_id: pathId, force: force ? '1' : undefined });
export const fetchIntersections = (state, district, rank, limit = 50) =>
  get('intersections', { state, district, rank, limit });
export const fetchCmfLibrary = () => get('cmf-library');
